import * as React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export function InformationDialog(props: {info: string, onClose: () => void })
{
	const { t } = useTranslation();

	return <Dialog open={props.info !== null}>
		<DialogTitle>{t("common.information")}</DialogTitle>
		<DialogContent>
			<DialogContentText>{props.info}</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button
				variant="contained"
				color="primary"
				onClick={props.onClose}
			>
				{t("common.action.ok")}
			</Button>
		</DialogActions>
	</Dialog>
}